import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

export default function About() {
    const { settings } = useSettings();
    return (
        <div className="relative z-10 pt-24 sm:pt-32 pb-24" data-testid="about-page">
            <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-16">
                <div className="grid lg:grid-cols-[1fr_1.3fr] gap-16 lg:gap-24">
                    <div className="lg:sticky lg:top-32 h-fit">
                        <img
                            src="https://images.unsplash.com/photo-1644375391877-0ae77eeed8fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxhcnRpc3QlMjBzdHVkaW8lMjBhZXN0aGV0aWN8ZW58MHx8fHwxNzg0MjU4NzgzfDA&ixlib=rb-4.1.0&q=85"
                            alt="Artist in studio"
                            className="w-full aspect-[3/4] object-cover"
                        />
                    </div>
                    <div>
                        <div className="label-caps text-[#8C3A3A] mb-6">About the Artist</div>
                        <h1 className="font-serif-display text-5xl sm:text-6xl font-light tracking-tighter text-[#1A1A1A] leading-none mb-10">
                            {settings.about_title_line1}<br /><span className="italic text-[#5A5A5A]">{settings.about_title_line2}</span>
                        </h1>
                        <div className="prose prose-invert text-[#5A5A5A] leading-relaxed space-y-6 text-base">
                            <p>{settings.about_paragraph_1}</p>
                            <p>{settings.about_paragraph_2}</p>
                        </div>

                        <div className="mt-12 border-t border-black/[0.06] pt-10" data-testid="about-contact">
                            <div className="label-caps text-[#8C3A3A] mb-6">Contact</div>
                            <dl className="grid sm:grid-cols-[120px_1fr] gap-y-4 gap-x-6 text-sm">
                                <dt className="label-caps">Email</dt>
                                <dd>
                                    <a href={`mailto:${settings.contact_email}`} className="text-[#1A1A1A] hover:text-[#8C3A3A] nav-link" data-testid="contact-email">
                                        {settings.contact_email}
                                    </a>
                                </dd>
                                <dt className="label-caps">Mobile</dt>
                                <dd>
                                    <a href={`tel:${(settings.contact_phone || '').replace(/\s/g, '')}`} className="text-[#1A1A1A] hover:text-[#8C3A3A] nav-link" data-testid="contact-mobile">
                                        {settings.contact_phone}
                                    </a>
                                </dd>
                                <dt className="label-caps">Instagram</dt>
                                <dd className="text-[#1A1A1A]">
                                    <a href={`https://instagram.com/${settings.instagram_personal}`} target="_blank" rel="noreferrer" className="hover:text-[#8C3A3A] nav-link" data-testid="contact-ig-personal">
                                        @{settings.instagram_personal}
                                    </a>
                                    <span className="text-[#8A8A8A] text-xs tracking-[0.15em] uppercase ml-2">— main</span>
                                    <span className="mx-3 text-[#8A8A8A]">·</span>
                                    <a href={`https://instagram.com/${settings.instagram_studio}`} target="_blank" rel="noreferrer" className="hover:text-[#8C3A3A] nav-link" data-testid="contact-ig-studio">
                                        @{settings.instagram_studio}
                                    </a>
                                    <span className="text-[#8A8A8A] text-xs tracking-[0.15em] uppercase ml-2">— portfolio</span>
                                </dd>
                            </dl>
                        </div>

                        <div className="mt-10 flex flex-wrap gap-4">
                            <Link to="/commissions" className="inline-flex items-center gap-3 bg-[#1A1A1A] text-[#FAFAF7] px-8 py-4 rounded-full text-sm tracking-wide font-medium hover:bg-[#8C3A3A] hover:text-white transition-colors" data-testid="about-commissions-btn">
                                Request a commission
                            </Link>
                            <a href="https://instagram.com/Nick_Moore" target="_blank" rel="noreferrer" className="inline-flex items-center gap-3 border border-black/20 text-[#1A1A1A] px-8 py-4 rounded-full text-sm tracking-wide hover:bg-black/5 transition-colors" data-testid="about-instagram-btn">
                                <Instagram className="w-4 h-4" /> @Nick_Moore
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
